import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser'
import SoundAssetKeys from '../SoundAssetKeys';
import DashedLine from '../ui/DashedLine';
import DemoLetterPart from './DemoLetterPart';
import InfoPopUp from './InfoPopUp';

export default class DemoLetter extends Phaser.GameObjects.Container
{
    /**
     * 
     * @param {Phaser.Scene} scene 
     */
    constructor(scene)
    {
        super(scene);

        this.movedOver = false;
        this.letterWidth = 350;
        this.letterHeight = 440;
        this.borderWidth = 15;

        this.letterBg = this.scene.add.rectangle(0, 0, this.letterWidth, this.letterHeight, 0xffffff).setOrigin(0);
        this.add(this.letterBg);

        this.letterParts = this.createAllParts();

        let i = 0;
        while (i < this.letterParts.length)
        {
            let part = this.letterParts[i];
            part.on("PART_SELECT", this.handlePartSelected, this);
            i++;
        }

        this.lineShape = new DashedLine(this.scene, 1.5, 0x3258A7, 3, 4);
        this.add(this.lineShape);

        this.partInfo = null;
    }

    createAllParts()
    {
        let heading = new DemoLetterPart(this.scene, ABCyaPhaser.Localization.instance.getLocalizedString('letter.heading'), 24, "HEADING");
        heading.x = this.letterWidth - heading.partWidth - this.borderWidth;
        heading.y = this.borderWidth;
        this.add(heading);
        let salutation = new DemoLetterPart(this.scene, ABCyaPhaser.Localization.instance.getLocalizedString('letter.salutation'), 24, "SALUTATION");
        salutation.x = this.borderWidth;
        salutation.y = heading.y + heading.partHeight + 40;
        this.add(salutation);
        let body = new DemoLetterPart(this.scene, ABCyaPhaser.Localization.instance.getLocalizedString('letter.body'), 75, "BODY");
        body.x = this.borderWidth;
        body.y = salutation.y + salutation.partHeight + 10;
        this.add(body);
        let closing = new DemoLetterPart(this.scene, ABCyaPhaser.Localization.instance.getLocalizedString('letter.closing'), 24, "CLOSING");
        closing.x = this.letterWidth - closing.partWidth - this.borderWidth;
        closing.y = body.y + body.partHeight + 40;
        this.add(closing);
        let signature = new DemoLetterPart(this.scene, ABCyaPhaser.Localization.instance.getLocalizedString('letter.signature'), 24, "SIGNATURE");
        signature.x = this.letterWidth - signature.partWidth - this.borderWidth;
        signature.y = closing.y + closing.partHeight + 10;
        this.add(signature);

        return [heading, salutation, body, closing, signature];
    }

    handlePartSelected(sender, partId)
    {
        //clear part info
        if (this.partInfo != null)
        {
            this.scene.tweens.killTweensOf(this.partInfo);
            this.delayShowPart?.remove();
            this.partInfo.destroy();
        }

        this.partInfo = new InfoPopUp(this.scene, partId);
        this.partInfo.x = this.letterWidth + 50;
        this.partInfo.y = -5;
        this.addAt(this.partInfo, this.getIndex(this.lineShape) - 1);

        let i = 0;
        while (i < this.letterParts.length)
        {
            let part = this.letterParts[i];
            if (part != sender && part.partState == "showing")
            {
                part.setShowState("clear");
            }
            i++;
        }

        ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._fast_whoosh_1, this.scene);
        //draw line to info
        let startPt = { x: sender.x + sender.getBounds().width - 10, y: sender.y };
        this.lineShape.drawBetween(startPt, { x: this.partInfo.x + 10, y: this.partInfo.y + 25 }, 200);
        this.delayShowPart = this.scene.time.delayedCall(200, this.partInfo.showPart, null, this.partInfo);
        ABCyaPhaser.Tweens.addTween(this, 200, {x: this.scene.scale.width/2 - ((this.partInfo.x + (this.partInfo.getBounds().width)) / 2)}, Phaser.Math.Easing.Linear);
    }
}